import 'braid-design-system/reset';
import { ApolloProvider } from '@apollo/client';
import {
  type ExperimentConfig,
  type FeatureFlagConfig,
  type FeatureFlagProviderProps,
  FeatureFlagProvider,
} from '@seek/candidate-feature-flag';
import { useMemo } from 'react';

import { candidateApolloClient } from 'src/modules/apollo/candidateApolloClient';

import type { ConfigStateContext } from '../shared/hooks/useConfig';

export const CandidateFeatureFlagApolloProvider = ({
  config,
  children,
}: {
  config: ConfigStateContext;
  children: React.ReactNode;
}) => {
  const client = candidateApolloClient(config); // createCandidateClient(config);
  return (
    <ApolloProvider client={client}>
      <FeatureFlagProvider {...useFeatureFlagProviderProps(config)}>
        {children}
      </FeatureFlagProvider>
    </ApolloProvider>
  );
};

const featureFlagsConfig: FeatureFlagConfig[] = [
  {
    key: 'zh-hk-language-support-for-hk',
  },
];

const experimentsConfig: ExperimentConfig[] = [];

const useFeatureFlagProviderProps = (
  config: ConfigStateContext,
): Omit<FeatureFlagProviderProps, 'children'> => {
  const isLocal = config.environment === 'development';
  const mockSeekOnlineVisitorId = '123e4567-e89b-12d3-a456-426614174000'; // Mock ID for local development
  const solId = !isLocal ? config.solId : mockSeekOnlineVisitorId;

  return useMemo<Omit<FeatureFlagProviderProps, 'children'>>(
    () => ({
      featureFlagsConfig,
      experimentsConfig,
      solId,
      customContext: {
        applicationContext: {
          key: solId,
          namespace: 'unified-apac',
          build: '1.0.0',
          version: '1.0.0',
        },
      },
      isLocal,
      shouldEnableOverride: true,
    }),
    [solId, isLocal],
  );
};
